export { ROLE_LABELS } from "@/lib/roles";

export const BOOK_KATEGORI = ["Novel", "Pelajaran", "Referensi", "Agama", "Umum", "Majalah", "Lainnya"];

export const KELAS_OPTIONS = ["7A", "7B", "7C", "8A", "8B", "8C", "9A", "9B", "9C"];

export const JENJANG_OPTIONS = ["TK", "SD", "SMP", "SMA"];

export const jenjangFromKelas = (kelas) => {
  const k = (kelas || "").trim().toUpperCase();
  if (!k) return "";
  if (/^(TK|PAUD|KB)/.test(k)) return "TK";
  const m = k.match(/^(\d{1,2})/);
  if (!m) return "";
  const g = +m[1];
  return g <= 6 ? "SD" : g <= 9 ? "SMP" : g <= 12 ? "SMA" : "";
};

export const BULAN = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export function formatCurrency(n) {
  const num = Number(n) || 0;
  return "SAR " + num.toLocaleString("id-ID");
}

export function yatimBadge(v) {
  if (!v || v === "Bukan") return null;
  return { label: v, cls: "border-purple-200 text-purple-700 bg-purple-50" };
}

export function ekonomiBadge(v) {
  if (!v) return null;
  const map = {
    "Mampu": "border-emerald-200 text-emerald-700 bg-emerald-50",
    "Kurang Mampu": "border-amber-200 text-amber-700 bg-amber-50",
    "Tidak Mampu": "border-red-200 text-red-700 bg-red-50",
  };
  return { label: v, cls: map[v] || "border-slate-200 text-slate-600 bg-slate-50" };
}

export const periodeLabel = (p) => (p?.item ? `${p.item} · TA ${p.tahun}/${Number(p.tahun) + 1}` : `${p?.bulan || ""} ${p?.tahun || ""}`);
